import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import SingleWirePage, { getDefaultData, getDefaultUI } from "components/pages/SingleWirePage";
import Classes, { Payee } from "model";
import { useEffect } from "react";

export default function CaptureSingleWireAccountDD(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const { branding } = context.state;

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["wire", "payee"], Payee.initByID(0))
    .submit();

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["fundingAccountSelectIsActive", "isActive"], true)
    .submit();
    
    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

  return (
    <SingleWirePage data={data} ui={ui} />
  )
}
